import React, { useState } from "react";
import { Link } from "react-router-dom";
import validator from "validator";
import Side from "./Side";
import validationLogin from "../../../validations/forms/auth/login";
import httpService from "../../../services/httpServices/httpServices";
import helperSpinner from "../../../helpers/spinner";
import SignInWithGoogle from "./SignInWithGoogle";

function Login() {
  const [message, setMessage] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    if (!params.has("status")) {
      return;
    }
    if (params.get("status") === "false") {
      return {
        type_class: "alert alert-danger m-0",
        text: params.get("message"),
        class_icon: "fa fa-exclamation-triangle",
      };
    }
  });
  let messageTag;

  if (message) {
    messageTag = (
      <div className="col-12 col-md-12 col-sm-12 col-lg-12 col-xl-12 py-3">
        <div className={`${message.type_class}`}>
          <i className={`${message.class_icon} pl-2`}></i>
          <span>{message.text}</span>
        </div>
      </div>
    );
  }
  const sendForm = async (e) => {
    e.preventDefault();
    const data = getDataForm();

    if (!data) {
      return;
    }

    helperSpinner.showSpinner(helperSpinner.CONTAINER_AUTH_PAGE);
    const resultLoginUser = await sendRequestLoginUser(data);
    helperSpinner.removeSpinner(helperSpinner.CONTAINER_AUTH_PAGE);
    if (!resultLoginUser) {
      return;
    }

    localStorage.setItem("token", resultLoginUser);
    const url = process.env.REACT_APP_DOMAIN;
    window.location.replace(url);
  };

  const sendRequestLoginUser = async (userData) => {
    const queryStringURl = new URLSearchParams(userData).toString();
    let result;
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/auth/login?" + queryStringURl
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger m-0",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return result.data.data;
  };

  const getDataForm = () => {
    const dataInputs = {
      credential: document.querySelector("#credential").value,
      password: document.querySelector("#password").value,
    };
    if (validationLogin(dataInputs) != true) {
      setMessage({
        type_class: "alert alert-danger m-0",
        text: validationLogin(dataInputs),
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    if (validator.isNumeric(dataInputs.credential)) {
      dataInputs.mobile = dataInputs.credential;
    } else {
      dataInputs.email = dataInputs.credential;
    }

    delete dataInputs.credential;
    return dataInputs;
  };

  return (
    <div
      className="ltr container-fluid container-auth-page"
      id="container-auth-page"
    >
      <div className="row h-100">
        <Side />
        <div
          className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 h-lg-100 py-5 p-lg-0"
          id="container-auth-page-box"
        >
          <div className="d-flex flex-column align-items-center justify-content-center h-100">
            <div id="auth-page-box">
              <div className="border-radius-auth-page">
                <div
                  className="header-box border-radius-auth-page py-1 px-3"
                  style={{ fontSize: "14px" }}
                >
                  ورود به حساب کاربری
                </div>
                <div className="body-box d-flex flex-column pt-5 pb-2 px-3">
                  <div className="login-auth-page-box">
                    <div className="d-flex ">
                      <div className="w-50 p-2">
                        <SignInWithGoogle
                          redirectUri={`${process.env.REACT_APP_DOMAIN_API}/v1/auth/login-with-google-publisher`}
                        />
                      </div>

                      <div className="d-flex align-items-center justify-content-center tab-login-with-hilite-auth-page w-50 pt-2 pr-2 ">
                        <div className="d-flex align-items-center justify-content-center w-100 h-100  p-2 ">
                          <div>با هایلایت</div>
                        </div>
                      </div>
                    </div>
                    <div className="px-2 form-login-with-hilite-auth-page">
                      <div className="px-2">
                        <form onSubmit={sendForm} dir="rtl">
                          {messageTag}
                          <div className="d-flex justify-content-center py-2">
                            <input
                              required
                              type="text"
                              id="credential"
                              className="form-control form-control-hilite w-auto"
                              placeholder="ایمیل یا شماره موبایل"
                            />
                          </div>
                          <div className="d-flex justify-content-center py-2">
                            <input
                              required
                              type="password"
                              id="password"
                              className="form-control form-control-hilite  w-auto"
                              placeholder="کلمه عبور"
                            />
                          </div>
                          <div className="d-flex py-3">
                            <button
                              type="submit"
                              className="btn btn-hilite-1 w-100 border-radius-auth-page"
                            >
                              ورود به حساب کاربری
                            </button>
                          </div>
                          <div className="py-2">
                            <Link
                              className="text-link-hilite"
                              to="/forget-password"
                            >
                              بازیابی کلمه عبور
                            </Link>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="py-1">
                    <span className="pl-2">هنوز ثبت نام نکرده اید؟</span>
                    <span>
                      <Link to="/register" className="text-link-hilite">
                        ثبت نام
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between pt-1">
                <span>info@hilite.ir</span>
                <span>۰۲۱-۶۶۷۵۷۳۷۹</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
